import React from 'react'

import classNames from 'classnames'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Map from '~/components/atoms/Map/Map'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import type { PartnerProps } from '../PartnerCard/PartnerCard'

import styles from './MapCard.module.css'

interface MapCardProps {
  variant?: 'bordered' | 'background'
  partner: PartnerProps
}

const MapCard: React.FC<MapCardProps> = ({
  variant = 'background',
  partner,
}) => {
  return (
    <>
      <Container>
        <div className={classNames(styles.base, styles[`${variant}Base`])}>
          <div className={styles.container}>
            <div className={styles.detailsContainer}>
              <Text size={TextSizes.bodyLrg} className={styles.name}>
                {partner.name}
              </Text>

              <p className={styles.address}>
                {partner.town && (
                  <Text size={TextSizes.bodyMed}>{partner.town}</Text>
                )}
                {partner.town && partner.city && (
                  <Text size={TextSizes.bodyMed}>{', '}</Text>
                )}

                <Text size={TextSizes.bodyMed}>{partner.city}</Text>
              </p>

              {partner.telephone && (
                <Text size={TextSizes.bodyLrg} className={styles.telephone}>
                  <a href={`tel:${partner.telephone}`}>{partner.telephone}</a>
                </Text>
              )}
              <div className={styles.buttonContainer}>
                {partner.siteUrl && (
                  <Button
                    variant={ButtonVariants.primaryDark}
                    className={styles.ctaLink}
                    iconLeft
                    link={partner.siteUrl}
                    target="_blank"
                  >
                    Visit Website
                  </Button>
                )}
                <Button
                  variant={ButtonVariants.secondaryDark}
                  className={styles.ctaLink}
                  link={`https://www.google.com/maps?q=${partner.geoLocation.lat},${partner.geoLocation.lng}`}
                  target="_blank"
                >
                  View on Google Maps
                </Button>
              </div>
            </div>
            <div className={styles.mapContainer} id="map">
              <Map locations={[partner]} height={250} />
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

export default MapCard
